import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filter-widget__search"
}
const _hoisted_2 = { class: "filter-widget__list" }
const _hoisted_3 = { class: "checkbox-widget__checker" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlInput = _resolveComponent("ControlInput")!
  const _component_ControlCheckbox = _resolveComponent("ControlCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.LIMIT_FOR_SEARCH < $setup.options.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ControlInput, {
            styling: "accent",
            "start-icon": 'i-search',
            "icon-size": ['lg'],
            placeholder: _ctx.$t('Search'),
            size: ['md'],
            onInput: $setup.debounceSearch
          }, null, 8, ["placeholder", "onInput"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedOptions, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "filter-widget__item",
          key: option.slug
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["checkbox-widget", { 'is-like-disabled': !$setup.checkSelected(option.id) && !$setup.availableIds.includes(option.id) }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_component_ControlCheckbox, {
                key: `${$setup.checkSelected(option.id)}`,
                id: `${$props.filter.slug}_${option.slug}`,
                name: $props.filter.slug,
                checked: $setup.checkSelected(option.id),
                value: option.slug,
                "onUpdate:modelValue": ($event: any) => ($setup.update($event, option))
              }, null, 8, ["id", "name", "checked", "value", "onUpdate:modelValue"]))
            ]),
            _createElementVNode("label", {
              class: "checkbox-widget__title",
              for: `${$props.filter.slug}_${option.slug}`
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(option?.value_verbose || option.title), 1)
            ], 8, _hoisted_4)
          ], 2)
        ]))
      }), 128))
    ])
  ], 64))
}